import React from 'react';
import { Helmet } from 'react-helmet-async';
import { TECHNOLOGY, PROCESS, ATMOSPHERE } from '../data/products';
import { Reveal } from '../components/Reveal';
import AtmoBg from '../components/AtmoBg';

export default function Technology() {
  return (
    <main data-testid="technology-page" className="bg-white text-[#111]">
      <Helmet>
        <title>Technology | MODULAROOM</title>
        <meta name="description" content="The engineering behind every luxury modular home. Structural steel, PU insulation, double glazing, aluminium shell, smart controls and factory-controlled build quality." />
        <link rel="canonical" href="https://modularoom.com/technology" />
      </Helmet>
      <section className="relative overflow-hidden pt-40 md:pt-52 pb-20">
        <AtmoBg src={ATMOSPHERE.technology} base="white" opacity={0.10} />
        <div className="relative max-w-[1440px] mx-auto px-6 md:px-12">
          <div className="text-[11px] tracking-[0.32em] uppercase text-black/50">Engineered for tomorrow</div>
          <h1 className="font-display text-5xl sm:text-6xl md:text-7xl mt-5 tracking-tight leading-[0.98] max-w-4xl">
            Every detail matters.
          </h1>
          <p className="mt-8 max-w-2xl text-lg text-black/65 leading-relaxed">
            Every MODULAROOM is engineered as a complete architectural product, not assembled on-site. From the structural frame to the finishing touches, every component is selected for durability, performance and timeless aesthetics.
          </p>
        </div>
      </section>

      <section className="bg-[#F5F5F5] py-24 md:py-32">
        <div className="max-w-[1440px] mx-auto px-6 md:px-12">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-x-16 gap-y-14">
            {TECHNOLOGY.map((t, i) => (
              <Reveal key={t.title} delay={i*0.04}>
                <div className="border-t border-black/15 pt-6 flex gap-6">
                  <div className="text-[11px] tracking-[0.32em] uppercase text-[#C7A36A] w-10 shrink-0">{String(i+1).padStart(2,'0')}</div>
                  <div>
                    <div className="font-display text-2xl md:text-3xl tracking-tight">{t.title}</div>
                    <div className="mt-3 text-black/65 leading-relaxed">{t.body}</div>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-[#111] text-white py-28 md:py-40">
        <div className="max-w-[1440px] mx-auto px-6 md:px-12">
          <div className="max-w-2xl">
            <div className="text-[11px] tracking-[0.32em] uppercase text-[#C7A36A]">Factory Built. Site Installed.</div>
            <h2 className="font-display text-4xl md:text-6xl mt-4 tracking-tight leading-[1.02]">Ready in days. Not months.</h2>
          </div>
          <div className="mt-16 grid grid-cols-1 md:grid-cols-5 gap-8 md:gap-6">
            {PROCESS.map((p) => (
              <Reveal key={p.step} className="border-t border-white/15 pt-6">
                <div className="text-[11px] tracking-[0.32em] uppercase text-[#C7A36A]">{p.step}</div>
                <div className="mt-3 font-display text-2xl tracking-tight">{p.title}</div>
                <div className="mt-3 text-sm text-white/70 leading-relaxed">{p.body}</div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </main>
  );
}
